import React, { useState } from 'react';

const logos = [
  { id: 1, label: 'BAZAAR' },
  { id: 2, label: 'GLAMOUR' },
  { id: 3, label: 'Wendy' },
  { id: 4, label: 'yoga' },
  { id: 5, label: 'Rolo' },
  { id: 6, label: 'The New York Times' },
];

const visibleCount = 4;
const logoWidth = 200;

const LogoSlider: React.FC = () => {
  const [startIdx, setStartIdx] = useState(0);

  const prev = () => {
    setStartIdx((prev) => (prev === 0 ? logos.length - visibleCount : prev - 1));
  };
  const next = () => {
    setStartIdx((prev) => (prev === logos.length - visibleCount ? 0 : prev + 1));
  };

  // For smooth sliding, show all logos in a row and translate the row
  const getTranslateX = () => {
    return -(startIdx * logoWidth);
  };

  return (
    <div className="w-full bg-[#505050] py-12 flex items-center justify-center">
      <button
        aria-label="Previous"
        onClick={prev}
        className="mx-8 text-3xl text-black bg-transparent border-none focus:outline-none hover:scale-110 transition-transform"
      >
        &#60;
      </button>
      <div className="overflow-hidden w-[1200px] max-w-full" style={{ height: '80px' }}>
        <div
          className="flex items-center gap-16 transition-transform duration-500 ease-in-out"
          style={{
            width: `${logos.length * logoWidth}px`,
            transform: `translateX(${getTranslateX()}px)`,
          }}
        >
          {logos.map((logo) => (
            <div
              key={logo.id}
              className="flex flex-col items-center justify-center text-white select-none text-2xl font-semibold bg-transparent"
              style={{ minWidth: `${logoWidth}px`, minHeight: '60px' }}
            >
              <span>{logo.label}</span>
            </div>
          ))}
        </div>
      </div>
      <button
        aria-label="Next"
        onClick={next}
        className="mx-8 text-3xl text-black bg-transparent border-none focus:outline-none hover:scale-110 transition-transform"
      >
        &#62;
      </button>
    </div>
  );
};

export default LogoSlider;
